import { AssignmentsListController } from './assignments-list.controller';
import { AssignmentsListProps } from './assignments-list.model';

export const AssignmentsList = (props: AssignmentsListProps) => {
  return <AssignmentsListController {...props} />;
};
